import React from "react";
import FileDownloadIcon from "@material-ui/icons/GetAppRounded";

const RESUME_URL = "/assets/Gayashan Hansaja.pdf";

/**
 * Quiet, always-available resume link. Pinned top-right on desktop, bottom-right
 * on mobile so it never collides with the compact header.
 */
const ResumeButton = () => (
    <a
        href={RESUME_URL}
        download="Gayashan_Hansaja_Resume.pdf"
        className="btn fixed bottom-5 right-5 z-50 border-line bg-canvas-deep/85
                   px-3.5 shadow-lift backdrop-blur-md sm:px-5 md:bottom-auto
                   md:right-6 md:top-6"
    >
        <FileDownloadIcon style={{ fontSize: 17 }} />
        <span className="hidden sm:inline">Resume</span>
    </a>
);

export default ResumeButton;
